// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2_6Gd","range":"MonthRangeSwitch_range__3bBsg","disabled":"MonthRangeSwitch_disabled__Jxw18"};